import angular from 'angular';
import ngStorage from 'ngstorage';
import ConfigsModule from '../../configs/configs';
import ServicesModule from '../../services/services';
import ResourcesModule from '../../resources/resources';
import template from './gamesSwitcher.jade';

export class GamesSwitcherController {
  /* @ngInject */
  constructor($q,$state,GameDevelopersResource,CampaignAnalyticsResource,MeResource,currentGame,currentGameDeveloper,currentUser,$filter,$localStorage,hideThatProduct,notify) {
    this.GameDevelopersResource = GameDevelopersResource;
    this.CampaignAnalyticsResource = CampaignAnalyticsResource;
    this.MeResource = MeResource;
    this.currentGame = currentGame;
    this.currentUser = currentUser;
    this.notify = notify;
    this.currentGameDeveloper = currentGameDeveloper;
    this.$state = $state;
    this.$localStorage = $localStorage;
    this.$q = $q;
    this.hideThatProduct = hideThatProduct;

    this.MeResource.one().get().then((user) => {
      this.currentUser.onNext(user);
      this.getGameDeveloper(user)
      .then(() => {
        if (user.hasRole(['DEMO'])) {
          this.$state.go('app.games.index');
        } else if (user.hasRole(['ADMIN'])) {
          this.$state.go('app.games.revenue');
        } else if (user.hasRole(['GG_ACCOUNT_MANAGER'])) {
          this.$state.go('app.admin.gameDevelopers.index');
        } else {
          this.$state.go('app.games.index');
        }
      });
    })
  }

  getGameDeveloper(user) {
    if (!_.isEmpty(user.game_developer_ids)) {
      return this.GameDevelopersResource.one(user.game_developer_ids[0]).get()
      .then(gameDeveloper => this.gameDeveloper = gameDeveloper)
      .catch(this.notify.apiError)
    } else {
      return {then: (cb) => cb()}
    }
  }

}

let GamesSwitcherComponent = {
  template: ($element, $attrs) => { return template; },
  controller: GamesSwitcherController,
  controllerAs: 'vm',
  bindings: true
};

export default angular.module('app.components.games.switcher', [
  ngStorage.name,
  ConfigsModule.name,
  ServicesModule.name,
  ResourcesModule.name
])
  .component('gamesSwitcher', GamesSwitcherComponent);



/** WEBPACK FOOTER **
 ** ./src/components/games/gamesSwitcher.js
 **/